import { ScheduledDowngradeService } from './services/ScheduledDowngradeService';
import type { Init } from './types';
import { managerHelpers } from '../../helpers';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export * from './ScheduledDowngradeBannerManager';

export type ScheduledDowngradeBannerData = MergedDataReturnType<[ScheduledDowngradeService]>;

export type ScheduledDowngradeBannerHandlers = MergedHandlersReturnType<[ScheduledDowngradeService]>;

type TApi = ReturnType<ScheduledDowngradeService['api']>;

export class ScheduledDowngradeBannerManager extends WithApi<TApi> {
  public scheduledDowngradeBannerInit = ({ pageStore, t, queries, mutations, isCoreMutationLockedAccount }: Init) => {
    const [hasScheduledDowngradeQuery] = queries;
    const [cancelScheduledDowngradeMutation] = mutations;

    const pending = hasScheduledDowngradeQuery.isLoading;
    const { error } = hasScheduledDowngradeQuery;

    if (pending) {
      return {
        status: 'pending',
        data: null,
        handlers: null,
      } as const;
    }

    if (error) {
      return {
        status: 'error',
        data: error,
        handlers: {
          retry: () => {
            managerHelpers.retryQueries(queries);
          },
        },
      } as const;
    }

    const scheduledDowngradeService = new ScheduledDowngradeService(
      !!hasScheduledDowngradeQuery.data,
      cancelScheduledDowngradeMutation,
      pageStore,
      t,
      isCoreMutationLockedAccount
    );

    this.initApi({
      ...scheduledDowngradeService.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...scheduledDowngradeService.data(),
      },
      handlers: {
        ...scheduledDowngradeService.handlers(),
      },
    } as const;
  };
}
